import { defineMessages } from "react-intl";

import { type AssessmentCopyVariants } from "@/modules/candidate/assessmentCopy";

const messages = defineMessages({
  assessmentContentLoadError: {
    id: "candidate.languageSelect.assessment.contentLoadError",
    defaultMessage:
      "We couldn't load this assessment in the language you selected. Please refresh and try again, or contact support.",
  },
  surveyContentLoadError: {
    id: "candidate.languageSelect.survey.contentLoadError",
    defaultMessage:
      "We couldn't load this survey in the language you selected. Please refresh and try again, or contact support.",
  },
});

export const contentLoadErrorMessages: AssessmentCopyVariants = {
  assessment: messages.assessmentContentLoadError,
  survey: messages.surveyContentLoadError,
};
